import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';



// Externals
import PropTypes from 'prop-types';
import { Chart } from 'react-chartjs-2';

// Material helpers
import { ThemeProvider } from '@material-ui/styles';
import { connect } from "react-redux";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';


// ChartJS helpers
import { chartjs } from './helpers';

// Theme
import theme from './theme';

// Styles
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';

// Routes
import Routes from './Routes';
import { clearErrors } from "actions/errorActions";

// Browser history
const browserHistory = createBrowserHistory();

// Configure ChartJS
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});



class App extends Component {
   isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
  
    return true
  }
  handleClose = () => {
    this.props.clearErrors();
  };handleOpen = (errors) => {
    if (!errors) {
      return false;
    }
  
    let errorD = true;
  
    if (errors.response) {
      console.log("🔍 Vérification des erreurs :", errors.response);
      if (errors.response.status === 401) {
        errorD = false; // ✅ Empêche l'affichage du pop-up pour `401`
      }
    }

    return errorD;
  };
  
  render() {
    //const {errors} = this.props;
    //const showError = this.handleOpen(errors);
    return ( 
      <ThemeProvider theme={theme}>
{ /*       <Dialog
          open={false}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"ERROR:"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {errors.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Got it
            </Button>
          </DialogActions>
        </Dialog>*/}
        <Router history={browserHistory}>
          <Routes />
        </Router>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  errors: state.errors,
});

export default connect(mapStateToProps, {clearErrors})(App);